

import React from "react";
import {
    createComponentBase,
    BaseComponentProps,
} from "../../../libs/components";
import { payloadType, ResponseType } from "../../../types";
import { Dropdown } from "../../atoms/dropdown";
import { FileUpload } from "../../atoms/fileUpload";
import { Modal } from "../../molecules/modal";
import { Divider } from "../../atoms/divider";
import { useSyncCollaboratorMutation } from "../../../store/box/boxSlice";
import { toast } from "react-toastify";
import { Loader } from "../../atoms/loader";

interface CollaboratorSynchronizeProps extends BaseComponentProps {
    isOpen: boolean;
    onClosed: (isOpen: boolean) => void;
}


export const SynchronizeBoxCollaborator = ({ className, isOpen, onClosed }: CollaboratorSynchronizeProps) => {
    const componentClassName = "o-synchronizeBoxCollaborator";
    const { Container } = createComponentBase(componentClassName, "div");
    const modifiers = {};

    const [syncCollaboratorAPI, { isLoading }] = useSyncCollaboratorMutation();

    const [isShowModal, setIsShowModal] = React.useState(isOpen);

    React.useEffect(() => {
        setIsShowModal(isOpen);
    }, [isOpen]);


    const initialPayload: payloadType = {
        type: {
            value: "" as unknown as { label: string; value: string },
            error: "",
            isError: false,
        },
        file: {
            value: "",
            error: "",
            isError: false,
        },
        fileName: {
            value: "",
            error: "",
            isError: false,
        },
    };

    const [payload, setPayload] = React.useState(initialPayload);

    const onClose = () => {
        setIsShowModal(false);
        onClosed(false);
        if (!isLoading)
            setPayload(initialPayload);
    }

    const submitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const formData = new FormData();

        formData.append("type", (payload.type.value as { label: string; value: string }).value);
        formData.append("file", payload.file.value as File);

        const response = await syncCollaboratorAPI(formData) as ResponseType;

        if (response?.data?.success) {
            toast.success(response?.data?.message);
            onClose();
        } else {
            if (response?.error?.data?.errors) {
                Object.keys(response?.error?.data?.errors).forEach((key) => {
                    setPayload((prevState) => ({
                        ...prevState,
                        [key]: {
                            ...prevState[key],
                            error: response?.error?.data?.errors[key][0],
                            isError: true,
                        },
                    }));
                });
            } else {
                toast.error(response?.error?.data?.message);
            }
        }

    };



    return (
        <Modal header="Synchronize Box Collaborators" onClose={onClose} className={className} isOpen={isShowModal}>
            <Loader isLoading={isLoading}>
                <Container className={className} modifiers={modifiers}>
                    <form className={`${componentClassName}__form`} onSubmit={submitHandler}>
                        <div className={`${componentClassName}__form__item`}>
                            <label className={`${componentClassName}__form__item__label`}>
                                Type
                            </label>
                            <Dropdown
                                placeholder="Select Type"
                                selected={payload.type.value as { label: string; value: string }}
                                options={[
                                    {
                                        label: "User Activity Data",
                                        value: "userActivityData",
                                    },
                                    {
                                        label: "Collaboration Data",
                                        value: "collaborationData",
                                    },
                                ]}
                                onClickChange={(selected) =>
                                    setPayload({
                                        ...payload,
                                        type: {
                                            value: selected as { label: string; value: string },
                                            error: "",
                                            isError: false,
                                        },
                                    })
                                }

                                isError={payload.type.isError}
                                error={payload.type.error}
                            />
                        </div>

                        <FileUpload
                            label="Upload File"
                            accept=".csv"
                            placeholder="Please choose a file"
                            fileName={payload.fileName.value as string}
                            onChange={(e) => {
                                if (e.target.files === null) return;
                                setPayload({
                                    ...payload,
                                    file: {
                                        value: e.target.files[0] as File,
                                        error: "",
                                        isError: false,
                                    },
                                    fileName: {
                                        value: e.target.files[0].name,
                                        error: "",
                                        isError: false,
                                    },
                                });
                            }}
                            isError={payload.file.isError}
                            error={payload.file.error}
                        />
                        <Divider />
                        <div className={`${componentClassName}__form__action`}>
                            <button
                                type="button"
                                onClick={onClose}
                                disabled={isLoading}
                                className={`${componentClassName}__form__action__button ${componentClassName}__form__action__button--cancel`}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className={`${componentClassName}__form__action__button`}
                                disabled={isLoading}
                            >
                                Synchronize
                            </button>
                        </div>

                    </form>
                </Container>
            </Loader>
        </Modal>
    );
};

